import axios, { AxiosError } from 'axios'

export const fileupload = async (url: string, files: FileList): Promise<void> => {
  try {
    await axios.put(url, files[0], { headers: { 'content-type': files[0].type } })
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error as AxiosError)
  }
}
